// @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'Workflow'. Did you mean to use 'import Workflow from "src/api-parsers/index"' instead?
import type {Workflow} from 'src/api-parsers/index';

import Store from './base';


export default class AudienceMemberWorkflowStore extends Store {
  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Store'.
  state: {
    [key: string]: Workflow[];
  };

  constructor() {
    super('audience-member-workflows');

    // @ts-expect-error - TS2698 - Spread types may only be created from object types.
    this.state = {...null};
  }

  get(audienceMemberId: string): Record<any, any>[] {
    return this.state[audienceMemberId];
  }

  set(audienceMemberId: string, workflows: Record<any, any>[]) {
    this.updateState({
      [audienceMemberId]: {
        $set: workflows,
      },
    });
  }
}
